var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('AdditionalSales',{attrs:{"payment-id":this.paymentId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }